import { render } from "./VehicleForm.vue?vue&type=template&id=181a8573&scoped=true"
import script from "./VehicleForm.vue?vue&type=script&lang=js"
export * from "./VehicleForm.vue?vue&type=script&lang=js"

import "./VehicleForm.vue?vue&type=style&index=0&id=181a8573&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-181a8573"]])

export default __exports__